'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _offkey = require('offkey');

var _lodash = require('lodash');

var _bound = require('./utils/bound');

var _percentage = require('./utils/percentage');

var _percentage2 = _interopRequireDefault(_percentage);

var _KeyHandler = require('./KeyHandler');

var _KeyHandler2 = _interopRequireDefault(_KeyHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 */
function makeDefaultText(_ref) {
	var value = _ref.value;

	return value;
}

/**
 *
 */
function makeDefaultStyle(_ref2) {
	var min = _ref2.min;
	var max = _ref2.max;
	var value = _ref2.value;
	var orientation = _ref2.orientation;

	var position = (0, _percentage2.default)(value, max, min);
	var property = orientation === 'horizontal' ? 'left' : 'bottom';

	return _defineProperty({}, property, position + '%');
}

/**
 *
 */
var SliderHandle = (_temp = _class = function (_Component) {
	_inherits(SliderHandle, _Component);

	/**
  *
  */


	/**
  *
  */
	function SliderHandle(props) {
		_classCallCheck(this, SliderHandle);

		var _this = _possibleConstructorReturn(this, (SliderHandle.__proto__ || Object.getPrototypeOf(SliderHandle)).call(this, props));

		(0, _lodash.bindAll)(_this, 'handleMouseDown', 'handleMin', 'handleMax', 'handleIncrement', 'handleBigIncrement', 'handleDecrement', 'handleBigDecrement');

		_this.state = {
			dragging: false
		};
		return _this;
	}

	/**
  *
  */


	/**
  *
  */


	_createClass(SliderHandle, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.button === 0) {
				var _props = this.props;
				var index = _props.index;
				var onDragStart = _props.onDragStart;

				onDragStart(index);
			}
		}

		/**
   *
   */

	}, {
		key: 'handleMin',
		value: function handleMin() {
			var _props2 = this.props;
			var index = _props2.index;
			var lowerBound = _props2.lowerBound;
			var onChange = _props2.onChange;

			onChange(index, lowerBound);
		}

		/**
   *
   */

	}, {
		key: 'handleMax',
		value: function handleMax() {
			var _props3 = this.props;
			var index = _props3.index;
			var upperBound = _props3.upperBound;
			var onChange = _props3.onChange;

			onChange(index, upperBound);
		}

		/**
   *
   */

	}, {
		key: 'handleIncrement',
		value: function handleIncrement() {
			var _props4 = this.props;
			var index = _props4.index;
			var value = _props4.value;
			var step = _props4.step;
			var upperBound = _props4.upperBound;
			var onChange = _props4.onChange;

			onChange(index, (0, _bound.atMost)(value + step, upperBound));
		}

		/**
   *
   */

	}, {
		key: 'handleBigIncrement',
		value: function handleBigIncrement() {
			var _props5 = this.props;
			var index = _props5.index;
			var value = _props5.value;
			var bigStep = _props5.bigStep;
			var upperBound = _props5.upperBound;
			var onChange = _props5.onChange;

			onChange(index, (0, _bound.atMost)(value + bigStep, upperBound));
		}

		/**
   *
   */

	}, {
		key: 'handleDecrement',
		value: function handleDecrement() {
			var _props6 = this.props;
			var index = _props6.index;
			var value = _props6.value;
			var step = _props6.step;
			var lowerBound = _props6.lowerBound;
			var onChange = _props6.onChange;

			onChange(index, (0, _bound.atLeast)(value - step, lowerBound));
		}

		/**
   *
   */

	}, {
		key: 'handleBigDecrement',
		value: function handleBigDecrement() {
			var _props7 = this.props;
			var index = _props7.index;
			var value = _props7.value;
			var bigStep = _props7.bigStep;
			var lowerBound = _props7.lowerBound;
			var onChange = _props7.onChange;

			onChange(index, (0, _bound.atLeast)(value - bigStep, lowerBound));
		}

		/**
   *
   */

	}, {
		key: 'render',
		value: function render() {
			var _ref4;

			var _props8 = this.props;
			var lowerBound = _props8.lowerBound;
			var upperBound = _props8.upperBound;
			var value = _props8.value;
			var makeText = _props8.makeText;
			var makeStyle = _props8.makeStyle;


			var text = makeText(this.props);
			var style = makeStyle(this.props);
			var className = (0, _classnames2.default)({
				'rea11y-SliderHandle': true,
				'is-dragging': this.state.dragging
			});

			return _react2.default.createElement(
				'div',
				{ className: className, style: style },
				_react2.default.createElement(
					_KeyHandler2.default,
					{
						handlers: (_ref4 = {}, _defineProperty(_ref4, _offkey.HOME, this.handleMin), _defineProperty(_ref4, _offkey.END, this.handleMax), _defineProperty(_ref4, _offkey.ARROW.UP, this.handleIncrement), _defineProperty(_ref4, _offkey.ARROW.RIGHT, this.handleIncrement), _defineProperty(_ref4, _offkey.PAGE_UP, this.handleBigIncrement), _defineProperty(_ref4, _offkey.ARROW.DOWN, this.handleDecrement), _defineProperty(_ref4, _offkey.ARROW.LEFT, this.handleDecrement), _defineProperty(_ref4, _offkey.PAGE_DOWN, this.handleBigDecrement), _ref4)
					},
					_react2.default.createElement('div', {
						className: 'rea11y-SliderHandle-control',
						role: 'slider',
						'aria-valuemin': lowerBound,
						'aria-valuemax': upperBound,
						'aria-valuenow': value,
						'aria-valuetext': text,
						onMouseDown: this.handleMouseDown,
						tabIndex: '0'
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'rea11y-SliderHandle-text' },
					text
				)
			);
		}
	}]);

	return SliderHandle;
}(_react.Component), _class.propTypes = {
	orientation: _react.PropTypes.string,
	index: _react.PropTypes.number,
	min: _react.PropTypes.number,
	max: _react.PropTypes.number,
	lowerBound: _react.PropTypes.number,
	upperBound: _react.PropTypes.number,
	value: _react.PropTypes.number,
	step: _react.PropTypes.number,
	bigStep: _react.PropTypes.number,
	makeText: _react.PropTypes.func,
	makeStyle: _react.PropTypes.func,
	onDragStart: _react.PropTypes.func,
	onChange: _react.PropTypes.func
}, _class.defaultProps = {
	orientation: 'horizontal',
	index: 0,
	min: 0,
	max: 100,
	lowerBound: 0,
	upperBound: 100,
	value: 0,
	step: 1,
	bigStep: 10,
	makeText: makeDefaultText,
	makeStyle: makeDefaultStyle,
	onDragStart: _lodash.noop,
	onChange: _lodash.noop
}, _temp);
exports.default = (0, _recompose.pure)(SliderHandle);